import React, { Component } from 'react';

export default class RequestDemoButton extends Component {

  componentDidMount() {
    let params = new URLSearchParams(window.location.search);
    window.localStorage.setItem('source', params.get('source') || 'effi');
  }

  render() {
    return (
      <span>
        <a
          className="btn btn-primary mb-2 request-trial"
          href="/form/"
          target='_blank'
        >
          {this.props.text}
        </a>
        <small>No credit card required</small>
      </span>
    );
  }
}
